<template>
  <div class="boletos-container">

    <!-- Navegação por Ícones -->
    <CardNavLocacao :pasta="pasta" class="mb-4" />

    <!-- Cabeçalho -->
    <div class="card boletos-card mb-4">
      <div class="boletos-card-header">
        <h3 class="mb-0">Boletos</h3>
      </div>
      <div class="boletos-card-body">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <span class="badge-campo"><strong>Pasta:</strong> {{ pasta }}</span>
            <span class="mx-2 text-muted">|</span>
            <span class="badge-campo"><strong>Referência do Imóvel:</strong> {{ referencia }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Parâmetros para Emissão -->
    <div class="card boletos-card mb-4">
      <div class="boletos-card-header">
        <h5 class="mb-0">Parâmetros para Emissão</h5>
      </div>
      <div class="boletos-card-body">
        <div class="row">
          <div class="col-md-2">
            <label>Valor Aluguel:</label>
            <input v-model="valorAluguel" class="form-control" readonly />
          </div>
          <div class="col-md-2">
            <label>Condomínio:</label>
            <input v-model="condominio" class="form-control" @input="formatarMoeda('condominio')" />
          </div>
          <div class="col-md-2">
            <label>IPTU:</label>
            <input v-model="iptu" class="form-control" readonly />
          </div>
          <div class="col-md-2" v-if="parseMoeda(fianca) > 0">
            <label>Seguro fiança:</label>
            <input v-model="fianca" class="form-control" readonly />
          </div>
          <div class="col-md-2">
            <label>Seguro incêndio:</label>
            <input v-model="seguro" class="form-control" @input="formatarMoeda('seguro')" />
          </div>
          <div class="col-md-2">
            <label>Taxa Boleto:</label>
            <input v-model="taxaBoleto" class="form-control" readonly />
          </div>
        </div>

        <!-- Outros Adicionais -->
        <div class="row mt-4">
          <div class="col-md-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <label class="mb-0 section-subtitle">Outros Adicionais</label>
              <button class="btn btn-adicionar" @click="adicionarCampo('outros')">+ Adicionar</button>
            </div>
            <div v-for="(item, i) in outros" :key="'outro'+i" class="row mb-2">
              <div class="col-md-6">
                <input v-model="item.descricao" class="form-control" placeholder="Descrição do valor" />
              </div>
              <div class="col-md-4">
                <input v-model="item.valor" class="form-control" @input="formatarMoedaCampo(item, 'valor')" />
              </div>
              <div class="col-md-2">
                <button class="btn btn-remover w-100" @click="removerCampo('outros', i)">Remover</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Descontos -->
        <div class="row mt-4">
          <div class="col-md-12">
            <label class="section-subtitle">Descontos</label>
            <div class="d-flex flex-wrap gap-2 mb-3">
              <button class="btn btn-desconto-preset" @click="adicionarCampo('descontos')">+ Adicionar</button>
              <button class="btn btn-desconto-preset" @click="adicionarCampo('descontos', 'Fundo de reserva')">Fundo de reserva</button>
              <button class="btn btn-desconto-preset" @click="adicionarCampo('descontos', 'Pintura')">Pintura</button>
              <button class="btn btn-desconto-preset" @click="adicionarCampo('descontos', 'Despesas Extraordinárias')">Despesas Extraordinárias</button>
              <button class="btn btn-desconto-preset" @click="adicionarCampo('descontos', 'Melhorias do Condomínio')">Melhorias do Condomínio</button>
              <button class="btn btn-desconto-preset" @click="adicionarCampo('descontos', 'Reforma Condomínio')">Reforma Condomínio</button>
              <button class="btn btn-desconto-preset" @click="adicionarCampo('descontos', 'Fundo de Obras')">Fundo de Obras</button>
              <button class="btn btn-desconto-preset mt-2" @click="adicionarCampo('descontos', 'Recomposição do fundo de reserva')">Recomposição do fundo de reserva</button>
            </div>
            <div v-for="(item, i) in descontos" :key="'desconto'+i" class="row mb-2">
              <div class="col-md-6">
                <input v-model="item.descricao" class="form-control" placeholder="Descrição do desconto" />
              </div>
              <div class="col-md-4">
                <input v-model="item.valor" class="form-control" @input="formatarMoedaCampo(item, 'valor')" />
              </div>
              <div class="col-md-2">
                <button class="btn btn-remover w-100" @click="removerCampo('descontos', i)">Remover</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Informações Complementares -->
    <div class="card boletos-card mb-4">
      <div class="boletos-card-header">
        <h5 class="mb-0">Informações Complementares</h5>
      </div>
      <div class="boletos-card-body">
        <div class="row">
          <div class="col-md-6">
            <label>Observações:</label>
            <textarea v-model="info" class="form-control" rows="3"></textarea>
          </div>
          <div class="col-md-3">
            <label>Vencimento:</label>
            <input type="date" v-model="vencimento" class="form-control" />
          </div>
          <div class="col-md-3">
            <label>Valor Total:</label>
            <input :value="valorTotalFormatado" class="form-control input-destaque" readonly />
          </div>
        </div>
      </div>
    </div>

    <!-- Informativo Rascunho -->
    <div class="alerta-rascunho mb-3">
      <span class="alerta-rascunho-icone">&#9432;</span>
      <div>
        <strong>Rascunho</strong> — Todos os boletos gerados são marcados como rascunho e podem ser editados.
        Para enviar, clique em "Visualizar", revise os valores e clique em "Enviar Qr code / boleto ao Locatário".
      </div>
    </div>

    <!-- Botão Gerar -->
    <div class="text-center mt-4 mb-5">
      <button class="btn btn-gerar" @click="gerarBoleto">GERAR BOLETO</button>
    </div>

    <!-- Boletos Gerados -->
    <div class="card boletos-card mb-5">
      <div class="boletos-card-header">
        <h5 class="mb-0">Boletos Gerados</h5>
      </div>
      <div class="boletos-card-body p-0">
        <div class="table-responsive">
          <table class="table table-boletos mb-0" v-if="boletos.length > 0">
            <thead>
              <tr>
                <th>Vencimento</th>
                <th>Valor total</th>
                <th>Data emissão</th>
                <th>Pago?</th>
                <th>Boleto</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="b in boletos" :key="b.id" :class="{ 'linha-rascunho': b.enviado != 1 && b.pago != 1 }">
                <td>{{ formatarDataBR(b.vencimento) }}</td>
                <td class="valor-cell">{{ formatarValorBR(b.valor_total) }}</td>
                <td>{{ formatarDataBR(b.data_emissao) }}</td>
                <td>
                  <span v-if="b.pago == 1" class="badge-pago pago-sim">Pago</span>
                  <span v-else-if="b.enviado == 1" class="badge-pago enviado-badge">Enviado</span>
                  <span v-else class="badge-pago rascunho-badge">Rascunho</span>
                </td>
                <td>
                  <a
                    v-if="b.arquivo_pdf"
                    :href="`${baseUrl}uploads/boletos/${b.arquivo_pdf}`"
                    target="_blank"
                    class="btn btn-ver-pdf"
                  >
                    Ver PDF
                  </a>
                </td>
                <td>
                  <router-link
                    class="btn btn-visualizar-boleto"
                    :to="`/edicaoBoleto/${pasta}/${b.id}`"
                  >
                    Visualizar
                  </router-link>
                  <button class="btn btn-excluir-boleto" @click="excluir(b.id)">Excluir</button>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-else class="text-muted text-center py-4 mb-0">Nenhum boleto gerado ainda.</p>
        </div>
      </div>
    </div>

    <!-- Botão de acesso rápido - Buscar Locações -->
    <router-link to="/buscaLocacoes" class="fab-buscar-locacoes" title="Buscar Locações">
      <span class="fab-icone">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </span>
      <span class="fab-texto">Buscar Locações</span>
    </router-link>

    <!-- Navegação por Ícones (rodapé) -->
    <CardNavLocacao :pasta="pasta" class="mt-4" />
  </div>
</template>

<script>
import axios from "axios";
import CardNavLocacao from "@/components/CardNavLocacao";

export default {
  components: { CardNavLocacao },
  data() {
    return {
      pasta: "",
      referencia: "",
      valorAluguel: "R$ 0,00",
      iptu: "R$ 0,00",
      fianca: "R$ 0,00",
      taxaBoleto: "R$ 0,00",
      condominio: "",
      seguro: "",
      vencimento: "",
      info: "",
      outros: [],
      descontos: [],
      boletos: [],
      baseUrl: "https://www2.royaljardim.com.br/sistema/",
    };
  },
  computed: {
    valorTotal() {
      const fixos =
        this.parseMoeda(this.valorAluguel) +
        this.parseMoeda(this.iptu) +
        this.parseMoeda(this.fianca) +
        this.parseMoeda(this.taxaBoleto) +
        this.parseMoeda(this.condominio) +
        this.parseMoeda(this.seguro);
      const somaOutros = this.outros.reduce((s, o) => s + this.parseMoeda(o.valor), 0);
      const somaDescontos = this.descontos.reduce((s, d) => s + this.parseMoeda(d.valor), 0);
      return fixos + somaOutros - somaDescontos;
    },
    valorTotalFormatado() {
      return this.valorTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
  mounted() {
    this.pasta = this.$route.params.id || "";
    this.carregarDados();
    this.listarBoletos();
  },
  methods: {
    carregarDados() {
    axios.post(this.baseUrl + "boletos", new URLSearchParams({
      acao: "dados",
      pasta: this.pasta
    }))
    .then(res => {
      const d = res.data;
      if (!d.erro) {
        this.valorAluguel = d.valor_aluguel;
        this.iptu = d.iptu;
        this.fianca = d.fianca;
        this.taxaBoleto = d.taxa_boleto;
        this.referencia = d.referencia;

        // Calcula a data de vencimento automaticamente
        this.vencimento = this.calcularVencimentoAutomatico(d.vencimento);
      }
    })
    .catch(err => console.error(err));
  },
    // Calcula data de vencimento automática com base em LOC_VENCIMENTO
  calcularVencimentoAutomatico(loc_vencimento) {
    try {
      const diaVencimento = parseInt(loc_vencimento, 10);
      const hoje = new Date();

      let ano = hoje.getFullYear();
      let mes = hoje.getMonth(); // 0 = janeiro
      const diaAtual = hoje.getDate();

      if (diaAtual > diaVencimento) {
        mes += 1; // vai para o próximo mês
        if (mes > 11) {
          mes = 0;
          ano += 1;
        }
      }

      // Cria data final
      const dataFinal = new Date(ano, mes, diaVencimento);

      // Converte para yyyy-MM-dd (para o campo type="date")
      const yyyy = dataFinal.getFullYear();
      const mm = String(dataFinal.getMonth() + 1).padStart(2, '0');
      const dd = String(dataFinal.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    } catch (e) {
      console.error("Erro ao calcular vencimento:", e);
      return "";
    }
  },
    listarBoletos() {
      axios.post(this.baseUrl + "boletos", new URLSearchParams({
        acao: "listar",
        pasta: this.pasta
      }))
      .then(res => {
        this.boletos = res.data;
      })
      .catch(err => console.error(err));
    },
   gerarBoleto() {
  const form = new FormData();
  form.append("acao", "salvar");
  form.append("pasta", this.pasta);
  form.append("vencimento", this.vencimento);
  form.append("valor_total", this.valorTotal);
  form.append("info", this.info);

  //  Inclui também os valores fixos e automáticos
  form.append("valor_aluguel", this.parseMoeda(this.valorAluguel));
  form.append("valor_iptu", this.parseMoeda(this.iptu));
  form.append("valor_fianca", this.parseMoeda(this.fianca));
  form.append("valor_taxa_boleto", this.parseMoeda(this.taxaBoleto));
  form.append("valor_condominio", this.parseMoeda(this.condominio));
  form.append("valor_seguro", this.parseMoeda(this.seguro));

  // Inclui os arrays dinâmicos
  form.append("outros", JSON.stringify(this.outros));
  form.append("descontos", JSON.stringify(this.descontos));

  axios.post(this.baseUrl + "boletos", form)
  .then(() => this.listarBoletos())
  .catch(err => console.error(err));
},
    excluir(id) {
      if (confirm("Deseja excluir este boleto?")) {
        axios.post(this.baseUrl + "boletos", new URLSearchParams({
          acao: "excluir",
          id: id
        }))
        .then(() => this.listarBoletos())
        .catch(err => console.error(err));
      }
    },
    adicionarCampo(tipo, descricao = "") {
      this[tipo].push({ descricao: descricao, valor: "" });
    },
    removerCampo(tipo, i) {
      this[tipo].splice(i, 1);
    },
    parseMoeda(v) {
      return parseFloat(v.replace(/[R$\s.]/g, "").replace(",", ".")) || 0;
    },
    formatarMoeda(campo) {
      this[campo] = this.formatarValor(this[campo]);
    },
    formatarMoedaCampo(obj, prop) {
      obj[prop] = this.formatarValor(obj[prop]);
    },
    formatarValor(v) {
      v = v.replace(/[^\d]/g, "");
      const num = parseFloat(v) / 100;
      return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    formatarValorBR(v) {
      return parseFloat(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  formatarDataBR(data) {
  if (!data) return "";
  // Corrige o bug de fuso horário (tratando a string como data local)
  const partes = data.split(/[-T\s:]/);
  const ano = parseInt(partes[0]);
  const mes = parseInt(partes[1]) - 1;
  const dia = parseInt(partes[2]);
  const d = new Date(ano, mes, dia);

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
},
  },
};
</script>

<style scoped>
/* ===== Container ===== */
.boletos-container {
  max-width: 1100px;
  margin: 0 auto;
}

/* ===== Cards de Seção ===== */
.boletos-card {
  border: 1px solid #e8e4e3;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  overflow: hidden;
}
.boletos-card-header {
  background: #4C1C17;
  color: #fff;
  padding: 12px 20px;
}
.boletos-card-header h3,
.boletos-card-header h5 {
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.boletos-card-header h3 {
  font-size: 17px;
}
.boletos-card-body {
  padding: 20px;
  background: #fff;
}
.badge-campo {
  font-size: 14px;
  color: #555;
}
.section-subtitle {
  color: #4C1C17;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* ===== Labels e Inputs ===== */
.boletos-card label {
  color: #4C1C17;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 5px;
}
.boletos-card .form-control {
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 9px 12px;
  font-size: 14px;
  transition: all 0.2s;
}
.boletos-card .form-control:focus {
  border-color: #4C1C17;
  box-shadow: 0 0 0 3px rgba(76,28,23,0.1);
}
.boletos-card .form-control[readonly] {
  background: #f8f6f5;
  color: #666;
}
.input-destaque {
  background: #4C1C17 !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 16px;
  border: none !important;
  text-align: center;
}

/* ===== Botões ===== */
.btn-adicionar {
  background: linear-gradient(135deg, #28a745, #218838);
  color: #fff;
  border: none;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.3);
}
.btn-adicionar:hover {
  background: linear-gradient(135deg, #34ce57, #28a745);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.btn-remover {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-remover:hover {
  background: linear-gradient(135deg, #e8616c, #dc3545);
  color: #fff;
  transform: translateY(-1px);
}

.btn-desconto-preset {
  background: rgba(76, 28, 23, 0.08);
  color: #4C1C17;
  border: 1px solid rgba(76, 28, 23, 0.2);
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  transition: all 0.2s;
}
.btn-desconto-preset:hover {
  background: #4C1C17;
  color: #fff;
  border-color: #4C1C17;
}

.btn-gerar {
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  border: none;
  padding: 14px 56px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 4px 16px rgba(76,28,23,0.3);
}
.btn-gerar:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(76,28,23,0.4);
}

/* ===== Tabela Boletos ===== */
.table-boletos thead {
  background: #4C1C17;
  color: #fff;
}
.table-boletos th {
  padding: 14px 16px;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}
.table-boletos td {
  padding: 14px 16px;
  vertical-align: middle;
  font-size: 14px;
}
.table-boletos tbody tr:hover {
  background: #f8f4f3;
}
.table-boletos tbody tr:last-child td {
  border-bottom: none;
}
.valor-cell {
  font-weight: 700;
  color: #4C1C17;
}

/* ===== Badge Pago ===== */
.badge-pago {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.pago-sim {
  background: #e8f5e9;
  color: #28a745;
}
.pago-nao {
  background: #ffe5e5;
  color: #dc3545;
}
.enviado-badge {
  background: #e8f5e9;
  color: #28a745;
}
.rascunho-badge {
  background: #fff8e1;
  color: #92400e;
}
.linha-rascunho {
  border-left: 3px solid #f59e0b;
  background-color: #fffdf5;
}

/* ===== Botões da Tabela ===== */
.btn-ver-pdf {
  background: rgba(108, 117, 125, 0.1);
  color: #6c757d;
  border: 1px solid rgba(108, 117, 125, 0.3);
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-ver-pdf:hover {
  background: #6c757d;
  color: #fff;
}

.btn-visualizar-boleto {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: #fff;
  border: none;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
  margin-right: 4px;
}
.btn-visualizar-boleto:hover {
  background: linear-gradient(135deg, #238cf5, #007bff);
  color: #fff;
  transform: translateY(-1px);
}

.btn-excluir-boleto {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: #fff;
  border: none;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-excluir-boleto:hover {
  background: linear-gradient(135deg, #e8616c, #dc3545);
  color: #fff;
  transform: translateY(-1px);
}

/* ===== Alerta Rascunho ===== */
.alerta-rascunho {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff8e1;
  border-left: 4px solid #f59e0b;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #78716c;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.alerta-rascunho strong {
  color: #92400e;
}
.alerta-rascunho-icone {
  font-size: 20px;
  color: #f59e0b;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 1px;
}

/* ===== FAB Buscar Locações ===== */
.fab-buscar-locacoes {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  padding: 14px 22px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 20px rgba(76,28,23,0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}
.fab-icone svg {
  width: 24px;
  height: 24px;
}
.fab-texto {
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  transition: all 0.3s ease;
}
.fab-buscar-locacoes:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(76,28,23,0.5);
}
.fab-buscar-locacoes:hover .fab-texto {
  max-width: 140px;
  opacity: 1;
}
.fab-buscar-locacoes::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50px;
  border: 2px solid #4C1C17;
  animation: fabPulse 2s infinite;
}
@keyframes fabPulse {
  0%   { transform: scale(1);   opacity: 0.8; }
  70%  { transform: scale(1.12); opacity: 0; }
  100% { transform: scale(1.12); opacity: 0; }
}
</style>
